import { useTranslation } from "react-i18next";
import { Tabs } from "@/core/ui";
import { OidcSettings } from "./OidcSettings";
import { SeasonsAdmin } from "./SeasonsAdmin";
import { TenantSettingsForm } from "./TenantSettingsForm";
import { UsersAdmin } from "./UsersAdmin";

export function AdminPage() {
  const { t } = useTranslation();
  return (
    <section>
      <h1 className="bt-page-title">{t("nav.admin")}</h1>
      <Tabs
        items={[
          { id: "settings", label: t("admin.tabs.settings"), content: <TenantSettingsForm /> },
          { id: "sso", label: t("admin.tabs.sso"), content: <OidcSettings /> },
          { id: "users", label: t("admin.tabs.users"), content: <UsersAdmin /> },
          { id: "seasons", label: t("admin.tabs.seasons"), content: <SeasonsAdmin /> },
        ]}
      />
    </section>
  );
}
